import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-send",
  "use": "icon-ic-send-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"icon-ic-send\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.805 2.33a.667.667 0 0 1 .155.698l-3.784 10.48a.987.987 0 0 1-1.81.064l-1.934-3.87-3.87-1.934a.987.987 0 0 1 .065-1.81l10.48-3.784a.667.667 0 0 1 .698.156Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol